import React, { useState } from "react";
import { Button, Col, Form, Modal, Row } from "react-bootstrap";
import PhoneInputCustom from "../../PhoneInputCustom/PhoneInputCustom";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import styled from "styled-components";
// css
import styles from "./MealsPop.module.scss";
import Select from "react-select";
import { useForm } from "react-hook-form";
import {
  useAddMealMutation,
  useUpdateMealMutation,
  //useAddStaffMutation
} from "../../../store/services/mealService";
import {
  useAddStaffMutation,
  useUpdateUserMutation,
} from "../../../store/services/userService";
import toast from "react-hot-toast";

const mealOptions = [
  { value: "Breakfast", label: "Breakfast" },
  { value: "Lunch", label: "Lunch" },
  { value: "Dinner", label: "Dinner" },
];

const StaffPop = ({ title, modalOpen, setModalOpen, edit }) => {
  console.log("edit", edit);

  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors },
  } = useForm({
    mode: "onTouched", // Validation mode set to 'onTouched'
    defaultValues: {
      // name: edit?.name || "",
      // mealCount: edit?.mealCount || "",
      // description: edit?.description || "",
      // status: edit?.status || "active",
      // mealType: edit?.mealType || [],

      firstName: edit?.firstName || "",
      lastName: edit?.lastName || "",
      email: edit?.email || "",
      password: edit?.password || "",
      mobileNumber: edit?.mobileNumber || "",
      // mobileNumber: edit?.mobileNumber
      //   ? edit?.countryCode + edit?.mobileNumber
      //   : "",
      // countryCode: edit?.countryCode || "",
    },
  });
  const [selectedMeals, setSelectedMeals] = useState(
    edit?.mealType
      ? mealOptions.filter((option) => edit.mealType.includes(option.value))
      : []
  );
  const [addStaff, { isLoading: isAdding }] = useAddStaffMutation();
  const [updateUser, { isLoading: isUpdating }] = useUpdateUserMutation();

  // Handler for react-select
  const handleMealChange = (selectedOptions) => {
    setSelectedMeals(selectedOptions || []);
    const mealValues = selectedOptions
      ? selectedOptions.map((option) => option.value)
      : [];
    setValue("mealType", mealValues); // Update react-hook-form state with an array of values
  };

  // Submit handler
  const onSubmit = async (data) => {
    try {
      if (edit !== null) {
        // Update existing meal
        await updateUser({
          userId: edit._id,
          updatedData: data,
        });
      } else {
        await addStaff(data).unwrap(); // Call deleteMeal and handle success
      }
      setModalOpen(false);
      return toast.success(`Staff ${edit ? "updated" : "Added"} successfully`);
    } catch (error) {
      console.error("Failed to delete the meal:", error); // Handle error
    }
  };

  const hideHandler = () => {
    setModalOpen(false);
  };
  return (
    <Modal
      show={modalOpen}
      className={`${styles.MealsPop} transparentModal`}
      onHide={hideHandler}
      backdrop={true}
      keyboard={false}
      centered
    >
      <Modal.Body className={`${styles.modalBody}`}>
        <div className="mx-auto">
          <h3 className="m-0 fw-bold themeBlue">{title}</h3>
          <Col lg="12" className="my-2">
            <Form onSubmit={handleSubmit(onSubmit)}>
              <Col lg="12" md="12" className="my-2">
                {/* Name Field */}
                <div className="py-2">
                  <label className="form-label fw-sbold text-muted ps-2 m-0">
                    First Name
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    // {...register("firstName", { required: "First name is required" })}
                    {...register("firstName", {
                      required: "Please enter first name",
                      validate: (value) => {
                        if (/^\s/.test(value)) {
                          return "First name cannot start with a space";
                        }
                        if (/[^a-zA-Z0-9\s]/.test(value)) {
                          return "First name cannot include special characters or emojis";
                        }
                        return true;
                      },
                    })}
                  />
                  {errors.firstName && (
                    <span className="text-danger">
                      {errors.firstName.message}
                    </span>
                  )}
                </div>

                <div className="py-2">
                  <label className="form-label fw-sbold text-muted ps-2 m-0">
                    Last Name
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    // {...register("lastName", { required: "Last name is required" })}
                    {...register("lastName", {
                      required: "Please enter last name",
                      validate: (value) => {
                        if (/^\s/.test(value)) {
                          return "Last name cannot start with a space";
                        }
                        if (/[^a-zA-Z0-9\s]/.test(value)) {
                          return "Last name cannot include special characters or emojis";
                        }
                        return true;
                      },
                    })}
                  />
                  {errors.lastName && (
                    <span className="text-danger">
                      {errors.lastName.message}
                    </span>
                  )}
                </div>

                <div className="py-2">
                  <label className="form-label fw-sbold text-muted ps-2 m-0">
                    Email
                  </label>
                  <input
                    type="email"
                    className="form-control"
                    autoComplete="off"
                    // {...register("email", { required: "Email is required" })}
                    {...register("email", {
                      required: "Please enter email",

                      validate: (value) => {
                        if (/^\s/.test(value)) {
                          return "Email cannot start with a space";
                        }
                        // if (/[^a-zA-Z0-9\s]/.test(value)) {
                        //   return "Email cannot include special characters or emojis";
                        // }
                        return true;
                      },
                    })}
                  />
                  {errors.email && (
                    <span className="text-danger">{errors.email.message}</span>
                  )}
                </div>

                <div className="py-2">
                  <label className="form-label fw-sbold text-muted ps-2 m-0">
                    Password
                  </label>
                  <input
                    type="password"
                    className="form-control"
                    autoComplete="off"
                    {...register("password", {
                      required: "Please enter password",
                    })}
                  />
                  {errors.password && (
                    <span className="text-danger">
                      {errors.password.message}
                    </span>
                  )}
                </div>

                {/* <div className="col-span-12 md:col-span-6">
                  <label
                    htmlFor="phone"
                    className="form-label m-0 font-normal pb-1 text-dark"
                  >
                    Phone Number
                  </label>
                  <PhoneWrp>
                    <PhoneInputCustom
                      className={`${styles.formControl} font-medium form-control rounded ${errors.mobileNumber ? "border-red-500" : "border-white"
                        }`}
                      {...register("mobileNumber", {
                        required: "Mobile number is required",
                      })}
                      handlePhoneChange={(value, data, event, formattedValue) => {
                        setValue("countryCode", data.dialCode);
                        const mobileNumber = value.startsWith(data?.dialCode)
                          ? value.slice(data?.dialCode?.length)
                          : value;

                        setValue("mobileNumber", mobileNumber);
                      }}
                      countryCode={edit?.countryCode + edit?.mobileNumber}
                      
                    />
                  </PhoneWrp>
                  {errors.mobileNumber && (
                    <p className="text-red-500">{errors.mobileNumber.message}</p>
                  )}
                </div> */}


                {/* <div className="col-span-12 md:col-span-6">
                  <label
                    htmlFor="phone"
                    className="form-label m-0 font-normal pb-1  text-dark"
                  >
                    Phone Number
                  </label>
                  <PhoneWrp>
                    <PhoneInputCustom
                      className={`${styles.formControl
                        } font-medium form-control rounded ${errors.mobileNumber ? "border-red-500" : "border-white"
                        }`}
                      {...register("mobileNumber", {
                        required: "MobileNumber number is required",
                      })}
                      handlePhoneChange={(value, data, event, formattedValue) => {
                        setValue("countryCode", data.dialCode);
                        const mobileNumber = value.startsWith(data?.dialCode)
                          ? value.slice(data?.dialCode?.length)
                          : value;

                        setValue("mobileNumber", mobileNumber);
                      }}
                      countryCode={edit?.countryCode + edit?.mobileNumber}
                      disabled={edit !== "profileDetail"}
                    />
                  </PhoneWrp>
                  {errors.phone && (
                    <p className="text-red-500">{errors.phone.message}</p>
                  )}
                </div> */}

                {/* <div className="py-2">
                  <label className="form-label fw-sbold text-muted ps-2 m-0">
                    Mobile Number
                  </label>
                  <PhoneInput
                    country={"ae"} // Set default country
                    value={""}
                    onChange={(value) => setValue("mobileNumber", value)}
                    inputClass="form-control"
                    containerClass="w-100"
                  />
                  {errors.mobileNumber && (
                    <span className="text-danger">
                      {errors.mobileNumber.message}
                    </span>
                  )}
                </div> */}

                <div className="py-2">
                  <label className="form-label fw-sbold text-muted ps-2 m-0">
                    Mobile Number
                  </label>
                  <input
                    type="number"
                    className="form-control"
                    {...register("mobileNumber", {
                      required: "Mobile number is required",
                    })}
                  />
                  {errors.mobileNumber && (
                    <span className="text-danger">
                      {errors.mobileNumber.message}
                    </span>
                  )}
                </div>

                {/* Meal Count Field */}
                {/* <div className="py-2">
                  <label className="form-label fw-sbold text-muted ps-2 m-0">
                    Meal Count
                  </label>
                  <input
                    type="number"
                    className="form-control"
                    {...register("mealCount", {
                      required: "Meal count is required",
                      min: 1,
                    })}
                  />
                  {errors.mealCount && (
                    <span className="text-danger">
                      {errors.mealCount.message}
                    </span>
                  )}
                </div> */}

                {/* Description Field */}
                {/* <div className="py-2">
                  <label className="form-label fw-sbold text-muted ps-2 m-0">
                    Description
                  </label>
                  <textarea
                    rows={7}
                    className="form-control h-auto"
                    {...register("description", {
                      required: "Description is required",
                    })}
                  ></textarea>
                  {errors.description && (
                    <span className="text-danger">
                      {errors.description.message}
                    </span>
                  )}
                </div> */}

                {/* Meal Type (Select) */}
                {/* <div className="py-2">
                  <label className="form-label fw-sbold text-muted ps-2 m-0">
                    Meal Types
                  </label>
                  <Select
                    isMulti
                    name="mealTypes"
                    options={mealOptions}
                    className="basic-multi-select"
                    classNamePrefix="select"
                    value={selectedMeals}
                    onChange={handleMealChange}
                    placeholder="Select meal types..."
                  />
                  {errors.mealTypes && (
                    <span className="text-danger">
                      {errors.mealTypes.message}
                    </span>
                  )}
                </div> */}

                {/* Status Field */}
                {/* <div className="py-2">
                  <label className="form-label fw-sbold text-muted ps-2 m-0">
                    Status
                  </label>
                  <ul className="list-unstyled ps-0 mb-0 d-flex align-items-start gap-10 ps-2 flex-wrap">
                    <li className="d-flex align-items-center">
                      <input
                        type="radio"
                        value="active"
                        {...register("status", {
                          required: "Status is required",
                        })}
                        className="form-check"
                      />
                      <label className="form-label fw-sbold text-muted ps-2 m-0">
                        Active
                      </label>
                    </li>
                    <li className="d-flex align-items-center">
                      <input
                        type="radio"
                        value="inactive"
                        {...register("status", {
                          required: "Status is required",
                        })}
                        className="form-check"
                      />
                      <label className="form-label fw-sbold text-muted ps-2 m-0">
                        Inactive
                      </label>
                    </li>
                  </ul>
                  {errors.status && (
                    <span className="text-danger">{errors.status.message}</span>
                  )}
                </div> */}
              </Col>

              {/* Submit & Cancel Buttons */}
              <Col lg="12" className="my-2">
                <div className="d-flex align-items-center justify-content-center gap-10">
                  <Button
                    className="d-flex align-items-center justify-content-center commonBtn"
                    type="submit"
                    disabled={isAdding || isUpdating}
                  >
                    Submit
                  </Button>
                  <Button
                    className="d-flex align-items-center justify-content-center commonBtn GreyBtn"
                    type="button"
                    onClick={() => {
                      setModalOpen(false);
                    }}
                  >
                    Cancel
                  </Button>
                </div>
              </Col>
            </Form>
          </Col>

          {/* <div className="btnWrpper mt-4 d-flex align-items-center justify-content-center gap-10">
            <div className="px-2 w-100">
              <Button
                onClick={hideHandler}
                className="fw-sbold d-flex align-items-center justify-content-center commonBtn w-100 GreyBtn"
              >
                Cancel
              </Button>
            </div>
            <div className="px-2 w-100">
              <Button
                onClick={confirmHandler}
                className="fw-sbold d-flex align-items-center justify-content-center commonBtn w-100"
              >
                {title}
              </Button>
            </div>
          </div> */}
        </div>
      </Modal.Body>
    </Modal>
  );
};

const PhoneWrp = styled.div`
  input {
    width: 100% !important;
    height: 50px !important;
  }
`;

export default StaffPop;
